import PropTypes from 'prop-types';
import NaraBrand from '../NaraBrand';
import { PoweredBy } from '../PoweredBy';
import './styles.css';

const AuthLayout = ({ title, subtitle, children }) => (
  <main className="auth-page">
    <section className="auth-card" aria-labelledby="auth-page-title">
      <NaraBrand
        size="lg"
        className="auth-brand"
      />

      <header className="auth-heading">
        <h1 id="auth-page-title">{title}</h1>
        <p>{subtitle}</p>
      </header>

      {children}
    </section>

    <PoweredBy />
  </main>
);

AuthLayout.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default AuthLayout;